<div class="_rating-page">

	<div class="_page-container">
		<div class="_container">

			@if (reservation && ratingForm) {

				@if(!reservationSubmitted) {
					<div class="_intro-container">
						<img class="_logo" src="{{reservation?.Tenant?.logo ?? './assets/imgs/digibank.png'}}" />

						@if(reservation?.Tenant?.name) {
							<p class="_title" style="margin-top: 0;">{{reservation?.Tenant?.name}}</p>
						}

						<p class="_title">{{'PUBLIC_RATING.TITLE' | translate}}: {{reservation.Event.name}}?</p>
						<p class="_intro" [translate]="'PUBLIC_RATING.INTRO'" [translateParams]="{date: reservation.CalendarEvent.startsAt | date:'dd/MM/yyyy', event: reservation.Event.name}"></p>
					</div>
	
					<div class="_rating-container">
						<rating-component [formControl]="ratingForm.get('score') | cast"></rating-component>  
	
						<form-textarea label="{{'PUBLIC_RATING.NOTE' | translate}}" [formControl]="ratingForm.get('note') | cast" type="text" placeholder="{{ 'PUBLIC_RATING.PLACEHOLDER' | translate }}" ></form-textarea>
					</div>
	
					<div class="_button-container">
						<button class="_button _save-button" (click)="submitRating()">
							<span [translate]="'PUBLIC_RATING.SUBMIT'"></span>
						</button>
					</div>
				} @else {
					<div class="_message-container">
						<ion-icon class="_success" src="./assets/icons/present-outline.svg"></ion-icon>
						<p [translate]="'PUBLIC_RATING.RATING_SUBMITTED'"></p>
					</div>
			 	}				

			} @else if (noReservationFound) {
				<div class="_message-container">
					<ion-icon class="_pending" src="./assets/icons/help-circle-outline.svg"></ion-icon>
					<p [translate]="'PUBLIC_RATING.NO_RESERVATION_FOUND'"></p>
				</div>
			} @else {
				<div class="_message-container">
					<ion-spinner name="circles"></ion-spinner>
					<p [translate]="'PUBLIC_RATING.LOADING_RESERVATION'"></p>
				</div>
			}

		</div>
	</div>
	
	<logo-slider-component></logo-slider-component>

</div>
